<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Criar Novo Termo</h2>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col cols="12" md="10" lg="8">
          <b-form @submit.prevent="submitForm">
            <!-- Category Info (hidden field, shown as info) -->
            <b-alert show variant="info" class="mb-4">
              <strong>Categoria:</strong> Termos de Compra (purchase_terms)
            </b-alert>

            <!-- Body Field with CKEditor -->
            <b-form-group
              label="Conteúdo do Termo:"
              label-for="term-body"
              description="Use o editor abaixo para criar o conteúdo do termo. O termo será criado com status 'Rascunho'."
            >
              <ckeditor
                id="term-body"
                :editor="editor"
                v-model="form.body"
                :config="editorConfig"
              ></ckeditor>
            </b-form-group>

            <!-- Validation Error -->
            <b-alert v-if="validationError" show variant="danger" class="mt-3">
              {{ validationError }}
            </b-alert>

            <!-- API Error -->
            <b-alert v-if="apiError" show variant="danger" class="mt-3">
              {{ apiError }}
            </b-alert>

            <!-- Success Message -->
            <b-alert v-if="successMessage" show variant="success" class="mt-3">
              {{ successMessage }}
            </b-alert>

            <!-- Submit Buttons -->
            <div class="mt-4">
              <b-button
                type="submit"
                variant="primary"
                :disabled="submitting"
                class="mr-2"
              >
                <b-spinner small v-if="submitting"></b-spinner>
                {{ submitting ? 'Criando...' : 'Criar Termo' }}
              </b-button>

              <b-button
                variant="secondary"
                :disabled="submitting"
                @click="goBack"
              >
                Cancelar
              </b-button>
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue2'
import Editor from 'ckeditor5-custom-build/build/ckeditor'

export default {
  name: 'TermsCreate',
  components: {
    ckeditor: CKEditor.component
  },
  data () {
    return {
      editor: Editor,
      form: {
        body: '',
        category: 'purchase_terms'
      },
      editorConfig: {
        fontSize: {
          options: [
            { title: 'Tiny', model: '12px' },
            { title: 'Small', model: '13px' },
            'default',
            { title: 'Big', model: '20px' },
            { title: 'Huge', model: '23px' }
          ]
        },
        link: {
          addTargetToExternalLinks: true
        }
      },
      validationError: '',
      apiError: '',
      successMessage: '',
      submitting: false
    }
  },
  methods: {
    validateForm () {
      this.validationError = ''

      // Remove HTML tags to check if body has actual content
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = this.form.body
      const textContent = tempDiv.textContent || tempDiv.innerText || ''

      if (!textContent.trim()) {
        this.validationError = 'O conteúdo do termo não pode estar vazio.'
        return false
      }

      return true
    },
    async submitForm () {
      // Clear previous messages
      this.validationError = ''
      this.apiError = ''
      this.successMessage = ''

      // Validate form
      if (!this.validateForm()) {
        return
      }

      this.submitting = true

      try {
        const payload = {
          body: this.form.body,
          category: this.form.category
        }

        await this.$http.post(
          process.env.VUE_APP_URL_APP + '/b/admin/terms',
          payload
        )

        this.successMessage = 'Termo criado com sucesso!'

        // Show success toast
        this.$bvToast.toast('O termo foi criado com status Rascunho.', {
          title: 'Termo Criado',
          autoHideDelay: 5000,
          variant: 'success',
          toaster: 'b-toaster-top-center',
          solid: true
        })

        // Redirect to list after short delay
        setTimeout(() => {
          this.$router.push({ name: 'AdminTermsList' })
        }, 1500)
      } catch (err) {
        console.error(err)
        this.apiError = err.body?.message || 'Erro ao criar termo. Por favor, tente novamente.'
      } finally {
        this.submitting = false
      }
    },
    goBack () {
      this.$router.push({ name: 'AdminTermsList' })
    }
  }
}
</script>

<style scoped>
/* Ensure CKEditor has minimum height */
::v-deep .ck-editor__editable {
  min-height: 400px;
}
</style>
